'use client';

import React from 'react';
import { Clock } from 'lucide-react';

export const TimelineReality: React.FC = () => {
  return (
    <div className="my-16">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-lg bg-amber-100 flex items-center justify-center">
          <Clock className="w-6 h-6 text-amber-600" />
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900">
          Why Most Never See Month 6
        </h2>
      </div>

      <div className="space-y-6 text-lg text-neutral-700 leading-relaxed">
        <p>
          Look at your Timeline view. Notice how Months 1-3 show minimal or negative returns?
        </p>

        <p>
          This is where 90% of loan officers quit when running ads alone. They've spent $7,500, closed one or two loans, and decided paid marketing doesn't work. With the Hybrid System, you're often profitable by Month 2-3.
        </p>

        <div className="bg-gradient-to-br from-amber-50 to-white border-2 border-amber-100 rounded-lg p-6 my-8">
          <p className="text-lg text-neutral-700 leading-relaxed mb-4">
            <strong className="text-neutral-900">Here's what they missed:</strong> Purchase leads typically take 6-12 months from initial contact to closed loan. These leads are in the early stages - thinking about buying, researching neighborhoods, getting finances together. They'll get pre-approved when they're actually ready to make offers, not when they first inquire. Leads generated in January often don't close until Q3, Q4, or even the following year.
          </p>
          <p className="text-lg text-neutral-700 leading-relaxed">
            With Paid Ads Only, this creates a brutal cash flow gap. With the Hybrid System, other revenue streams activate while you wait for those purchase leads to close. Agent partnerships can start Month 1. Your database begins converting Month 2-3. This is why Hybrid often hits profitability early while Paid Ads Only takes 6+ months.
          </p>
        </div>

        <p>
          With Paid Ads Only, momentum is slow. With the Hybrid System, early profitability bridges you to Month 7-12, when significant compound returns materialize.
        </p>

        <div className="bg-neutral-50 border-l-4 border-amber-500 p-6 rounded-r-lg">
          <p className="text-lg font-semibold text-neutral-900">
            The Timeline view isn't showing you a slow failure. It's showing you a normal business building pattern that most never see because they quit at the worst possible moment.
          </p>
        </div>
      </div>
    </div>
  );
};
